var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDonated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.90909 0.272705H16V8.99998H2.90909V0.272705ZM9.45455 2.45452C10.0332 2.45452 10.5882 2.68439 10.9973 3.09356C11.4065 3.50273 11.6364 4.05769 11.6364 4.63634C11.6364 5.215 11.4065 5.76995 10.9973 6.17912C10.5882 6.58829 10.0332 6.81816 9.45455 6.81816C8.87589 6.81816 8.32094 6.58829 7.91177 6.17912C7.5026 5.76995 7.27273 5.215 7.27273 4.63634C7.27273 4.05769 7.5026 3.50273 7.91177 3.09356C8.32094 2.68439 8.87589 2.45452 9.45455 2.45452V2.45452ZM5.81818 1.72725C5.81818 2.11302 5.66494 2.48299 5.39216 2.75577C5.11938 3.02855 4.74941 3.1818 4.36364 3.1818V6.09089C4.74941 6.09089 5.11938 6.24413 5.39216 6.51691C5.66494 6.78969 5.81818 7.15966 5.81818 7.54543H13.0909C13.0909 7.15966 13.2442 6.78969 13.5169 6.51691C13.7897 6.24413 14.1597 6.09089 14.5455 6.09089V3.1818C14.1597 3.1818 13.7897 3.02855 13.5169 2.75577C13.2442 2.48299 13.0909 2.11302 13.0909 1.72725H5.81818ZM0 3.1818H1.45455V10.4545H13.0909V11.9091H0V3.1818Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonated);
export default __webpack_public_path__ + "static/media/donated.c3f7c3b2.svg";
export { ForwardRef as ReactComponent };